export default "__VITE_PUBLIC_ASSET__f57f5550__"